import {Bottom, Top, LinkButton, RiveFetch} from "parts";
import {useStep} from "utils";
import {useTranslation} from 'react-i18next';
import {ReactComponent as CommentIcon} from 'assets/img/icon/comment.svg'

export function PrePaywall1({step, toAdd, nextUrl, preload}) {
  const
    {t, i18n} = useTranslation('common', {keyPrefix: 'prepaywall1'})

  useStep({step, toAdd})

  return (
    <>
      <style>{
`#root { background: url("/charisma/static/img/prepaywall/top.png") repeat-x 50% -48px; background-size: 390px auto }
.line-progress { background: url("/charisma/assets/img/prepaywall/line.svg") no-repeat 28px 32px }
.line-progress > .row:nth-child(odd) { margin-left: 40px; width: calc(100% - 40px) }
.line-progress > .row > div { max-width: 208px }
.popup { position: absolute; margin-left: -8px; margin-top: -85px; border-radius: 6px; background-color: #3ED06A; color: black; padding: 6px 8px }
.popup:after { content: ''; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 10px solid transparent; border-right: 10px solid transparent; border-top: 10px solid var(--secondary-green-light) }`
      }</style>
      <div className={'wrap fixed'}>
        <Top type={'center gap-3'}>
          <h1 className={'pre-line'}>{t('h1')}</h1>

          <div className={'row w-auto mb-4'}>
            <div className={'surface px-2 py-1 small tg row w-auto gap-2'} style={{backgroundColor: '#333A49'}}>
              <img width={16} height={16} src={'/static/img/icon/star.svg'} alt="★"/>
              {t('exercises', {
                count: 87
              })}
            </div>

            <div className={'surface px-2 py-1 small tg row w-auto gap-2'} style={{backgroundColor: '#333A49'}}>
              <CommentIcon fill={'#F6C558'}/>
              {t('tips', {
                count: 128
              })}
            </div>
          </div>

          {
            i18n.resolvedLanguage === 'en'
              ?
              <RiveFetch className={'mt-auto w-100'} width={390} height={458} style={{pointerEvents: 'none', width: 'calc(100% - 25px)'}}
                         src={'charisma_quiz.riv'} module={true}
                         artboard={'illustration-2'} stateMachines={'State Machine 1'}
              />
              :
              <div className={'mt-auto pre-line text-start line-progress stack gap-5'}>
                {
                  t('list', {returnObjects: true}).map(({name, desc}, i) =>
                    <div key={i} className={'row'} style={{gap: 40}}>
                      {
                        !i &&
                        <div className={'popup small-sm fw-bold'}>{t('here')}</div>
                      }
                      <img width={62} height={30}
                           src={`/charisma/static/img/prepaywall/${!i ? 'step_green' : 'step_grey'}.svg`} alt=""/>
                      <div>
                        <p className={'fw-bold' + (!i ? ' success-text' : '')}>{name}</p>
                        <small className={'notice-2'}>{desc}</small>
                      </div>
                    </div>
                  )
                }
                <div className={'row w-auto'} style={{marginTop: -20, marginLeft: 20}}>
                  <img width={100} height={100} alt="" src={'/charisma/static/img/prepaywall/star.svg'}/>
                  <strong style={{color: '#F6C558'}}>{t('star')}</strong>
                </div>
              </div>
          }

          <LinkButton to={nextUrl}>{t('btn')}</LinkButton>
        </Top>

        <Bottom footer={false} preload={preload}/>
      </div>
    </>
  )
}